var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 10.6944V14.8611C14.1667 15.2295 14.0203 15.5827 13.7599 15.8432C13.4994 16.1037 13.1461 16.25 12.7778 16.25H5.13889C4.77053 16.25 4.41726 16.1037 4.1568 15.8432C3.89633 15.5827 3.75 15.2295 3.75 14.8611V7.22222C3.75 6.85387 3.89633 6.5006 4.1568 6.24013C4.41726 5.97966 4.77053 5.83333 5.13889 5.83333H9.30556M12.0833 3.75H16.25M16.25 3.75V7.91667M16.25 3.75L8.61111 11.3889",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "daa85ecf1d7ff79219ca8a8809b4a910.svg";
export { ForwardRef as ReactComponent };